import { Injectable }         from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import {
	NgbDatepickerI18n,
	NgbDateStruct
}                             from '@ng-bootstrap/ng-bootstrap';


/** Custom service providing i18n getters for months and weekdays in the calendar widget */
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

	basePath = 'datepicker';

	constructor( private readonly _translationService: TranslationService ) {
		super();
	}

	getMonthShortName( month: number ): string {
		return this._translationService.getI18nString(
			true,
			this.basePath,
			`monthShortName.month${ month }`
		);
	}

	/* TODO --- check ---
	 *  This method does NOT what its name implies.
	 *  However, the `datepicker` branch of the i18n maps does not hold
	 *  long names of months, only the `month` branch
	 *  (used by ArchivingErsUsageComponent) does.
	 */
	getMonthFullName( month: number ): string {
		return this.getMonthShortName( month );
	}

	getDayAriaLabel( date: NgbDateStruct ): string {
		return `${ date.day }-${ date.month }-${ date.year }`;
	}

	getWeekdayLabel( weekday: number, width?: 'long' | 'short' | 'narrow' ): string {
		return this._translationService.getI18nString(
			true,
			this.basePath,
			`weekdayShortName.day${ weekday }`
		);
	}
}
